
import React from 'react';

// import styled from 'styled-components'

// const Svg = styled.svg`
// 	.cls-1{fill:none;stroke:#2d2d2d;stroke-linejoin:round;stroke-width:2px;}
// `

const Rocket = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M26.993 5.494a.992.992 0 00-.43-.43c-.24-.12-6-2.97-10.16 1.19l-2.49 2.48c-2.23-1.03-6.29-1.71-9.52 1.51a.996.996 0 000 1.41l4 4 8 8 4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29 3.22-3.22 2.54-7.29 1.52-9.52l2.48-2.48c4.21-4.2 1.3-9.92 1.18-10.16zm-14.62 4.78l-3.27 3.26-2.53-2.53c2.12-1.57 4.42-1.2 5.8-.73zm8.68 15.21l-2.53-2.53.49-.49 2.77-2.77c.45 1.37.82 3.68-.73 5.79zm3.34-11.24l-3 3-4.29 4.29-6.59-6.59 4.29-4.29 3-3c2.7-2.7 6.46-1.41 7.54-.95.48 1.08 1.79 4.8-.95 7.54zM8.813 17.247l-1.415 1.414 6.004 6.004 1.414-1.415-6.003-6.003z'
			></path>
			<path
				fill='#2d2d2d'
				d='M20.102 8.954c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM6.4 20.242l-2 2.001 1.413 1.414 2.001-2L6.4 20.241zM10.4 24.242l-2 2.001 1.413 1.414 2.002-2-1.415-1.415zM8.395 22.247l-2.998 2.998 1.414 1.414 2.998-2.998-1.414-1.414z'
			></path>
		</svg>
	);
};

export default Rocket;
